import React from 'react';
import { Show, SimpleShowLayout } from 'react-admin';

import ChangeHistory from '../../Common/Partials/ChangeHistory';
import ShowActions from '../../Common/Actions/Show';
import TeamTitleName from './StaticData/TitleName';
import Title from '../../Common/Title';

type Props = {
  basePath: string,
  record: any,
  resource: any
};

const TeamShow = (props: Props) => (
  <Show title={<Title title={TeamTitleName} record={props.record} />} actions={<ShowActions basePath={props.basePath} resource={props.resource} />} {...props}>
    <SimpleShowLayout>
      <ChangeHistory basePath={props.basePath} record={props.record} resource={props.resource} />
    </SimpleShowLayout>
  </Show>
);

export default TeamShow;



// WEBPACK FOOTER //
// ./src/views/Components/Teams/Show.tsx